import React, { Component } from "react";
import { observer } from "mobx-react";
import { Row, Col } from "react-flexbox-grid";

import PasswordFields from "./password-fields";
import PermissionsFields from "./permissions-fields";
import { CNPJ } from "cpf_cnpj";
import Paper from "material-ui-next/Paper";

import {
  CheckBox,
  EntitySelector,
  If,
  TextField,
  Loadable
} from "components/support";

import style from "./style";

class UserFormGeneralInfo extends Component {
  setField = (field, value) => {
    this.props.onChangeFormField({ field, value });
  };

  handleChange = (value, field) => {
    const validation = this.props.presenter.doValidateField(value, field);

    if (!!validation) {
      for (const key of Object.keys(validation)) {
        validation[key].forEach(error => {
          // Show just the error of current field
          if (key === field) {
            this.props.setFieldError(key, error);
          }
        });
      }
      // If there are validation errors but the current field is correct
      if (!Object.keys(validation).includes(field)) {
        this.props.setFieldError(field, "");
      }
    } else {
      this.props.setFieldError(field, "");
    }
    this.setField(field, value);
  };

  render() {
    const { presenter, viewModel, form, errors, className } = this.props;
    const {
      currentUser,
      companySearchOptions,
      allowedCompanies,
      filterLoading,
      filter,
      isSalesManProps
    } = viewModel;

    const firstCompanyChecked = uuid => {
      const checkedCompanies = form.allowed_companies_uuids;
      const result = checkedCompanies.includes(uuid) ? true : false;
      return result;
    };

    const ifLastCompanyChecked = uuid => {
      const checkedCompanies = form.allowed_companies_uuids;
      const lastCompanyChecked =
        checkedCompanies.length === 1 && checkedCompanies.includes(uuid);
      const result = lastCompanyChecked ? true : false;
      return result;
    };

    return (
      <div className={`grid-container ${className}`}>
        <Row>
          <Col xs={12} lg={6}>
            <div className="grid-container mb-sm">
              <Row>
                <Col xs={12}>
                  <TextField
                    noMargin
                    fullWidth
                    value={form.name}
                    floatingLabelFixed={true}
                    floatingLabelText="Nome"
                    errorText={errors.name}
                    onChange={(_, value) => this.handleChange(value, "name")}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <TextField
                    fullWidth
                    value={form.username}
                    floatingLabelFixed={true}
                    floatingLabelText="E-mail"
                    errorText={errors.username}
                    type="email"
                    onChange={(_, value) =>
                      this.handleChange(value, "username")
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <EntitySelector
                    label="Empresa"
                    title="Selecionar Empresa"
                    value={form.company.slug}
                    searchOptions={companySearchOptions}
                    onSelect={company => presenter.onSelectCompany(company)}
                    parser={company => ({
                      key: company.uuid,
                      title: company.slug,
                      subtext: company.fiscal_informations
                        ? CNPJ.format(company.fiscal_informations.cnpj)
                        : ""
                    })}
                  />
                </Col>
              </Row>
            </div>
          </Col>
          <Col xs={12} lg={6}>
            <div className="allowed-companies-main-div">
              <span className="label-class">Empresas disponíveis</span>
              <Paper elevation={2} className="paper-class">
                <Loadable loading={filterLoading}>
                  <div className="grid-container allowed-companies">
                    <Row>
                      <Col xs>
                        <TextField
                          allowClear
                          fullWidth
                          label="Nome da Empresa"
                          value={filter}
                          onChange={(_, value) =>
                            presenter.onFilterChange(value)
                          }
                        />
                      </Col>
                    </Row>
                    <Row>
                      {allowedCompanies.map((company, index) => {
                        return (
                          <Col
                            xs={6}
                            key={`col-${index}`}
                            className="allowed-companies-col"
                          >
                            <Row middle="xs">
                              <Col xs={3}>
                                <CheckBox
                                  checked={firstCompanyChecked(company.uuid)}
                                  onCheck={() =>
                                    presenter.onCheckCompany(company.uuid)
                                  }
                                  disabled={ifLastCompanyChecked(company.uuid)}
                                />
                              </Col>
                              <Col xs={9}>
                                <If test={company.cnpj}>
                                  <span className="allowed-companies-slug">
                                    {company.slug}
                                  </span>
                                  <span className="allowed-companies-cnpj">
                                    {company.cnpj}
                                  </span>
                                </If>
                                <If test={!company.cnpj}>
                                  <span className="allowed-companies-slug">
                                    {company.slug}
                                  </span>
                                </If>
                              </Col>
                            </Row>
                          </Col>
                        );
                      })}
                    </Row>
                  </div>
                </Loadable>
              </Paper>
            </div>
            <Row middle="xs">
              <Col xs={1}>
                <CheckBox
                  checked={form.is_salesman}
                  onCheck={() => presenter.onChangeIsSalesMan(isSalesManProps)}
                />
              </Col>
              <Col xs={11}>
                <span className="allowed-companies-slug">
                  Esse usuário é um vendedor
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
        <div className="password-fields">
          <PasswordFields
            mode={this.props.mode}
            form={this.props.form}
            errors={this.props.errors}
            onChange={this.handleChange}
            setFieldError={this.props.setFieldError}
            changePassword={this.props.changePassword}
          />
        </div>
        <div className="permission-fields">
          <PermissionsFields
            mode={this.props.mode}
            form={this.props.form}
            errors={this.props.errors}
            onChange={this.handleChange}
            setFieldError={this.props.setFieldError}
            currentUser={currentUser}
          />
        </div>
      </div>
    );
  }
}
export default style(observer(UserFormGeneralInfo));



// WEBPACK FOOTER //
// ./src/components/app/registration/user/form/general-info/general-info.view.jsx